import { motion } from 'framer-motion';
import { Menu } from 'lucide-react';

function Header({ onMenuClick, employeeCount }) {
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="sticky top-0 z-30 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-800"
    >
      <div className="flex items-center justify-between px-4 lg:px-6 h-16">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400 transition-colors"
        >
          <Menu size={24} />
        </button>

        <div className="flex-1 lg:ml-0">
          <h1 className="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white">
            Employee Management
          </h1>
        </div>

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2 }}
          className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
        >
          <span className="text-sm font-medium">
            {employeeCount} {employeeCount === 1 ? 'Employee' : 'Employees'}
          </span>
        </motion.div>
      </div>
    </motion.header>
  );
}

export default Header;
